module.exports = __webpack_public_path__ + "img/ilus-web-01.cc45c9ff.svg";